import React, { useState, forwardRef, useImperativeHandle, useEffect } from "react";
import { CustomConfirmAlert as confirmAlert } from '../../custom-confirm-alert';
import { useTranslation } from 'react-i18next';
import { Menu, MenuItem, MenuButton } from '@szhsin/react-menu';
import ApiClient from "../../../services/api-client"
import { toast } from 'react-toastify';
import { useNavigate } from "react-router-dom"
import useStore from "../../../hooks/useStore";

const SaleActionsRenderer = forwardRef((props, ref) => {
    const { t } = useTranslation();
    const [actionElement, setActionElement] = useState(<span></span>);
    const navigate = useNavigate();

    const goToPublic = () => {
        window.open("/mydata/" + props.data.invoiceUid, "_blank");
    }

    const handlePdfDownload = () => {
        props.colDef.cellRendererParams.pdfDownload(props.data)
    }

    const handleServerPdfDownload = () => {
        var _data = props.data;
        var companyId = useStore.getState().selectedCompany.id;
        ApiClient.getSaleInstancePrintForm(companyId, _data.id).then(
            response => {
                var _template = response.data.templateSettings;
                var printData = response.data.saleInstance;
                props.colDef.cellRendererParams.setTemplate(_template);
                var saleInstance = props.colDef.cellRendererParams.getPrintSale(printData);
                saleInstance.LOGO = _template.logo;
                saleInstance.IBAN = _template.iban;
                saleInstance.MOREINFO = _template.moreInfo;
                props.colDef.cellRendererParams.pdfDownloadServer(saleInstance);
            },
            error => {
                console.error(
                    (error.response && error.response.data && error.response.data.message) ||
                    error.message ||
                    error.toString()
                )
            }
        );
    }

    const handlePrint = () => {
        var _data = props.data;
        var companyId = useStore.getState().selectedCompany.id;
        ApiClient.getSaleInstancePrintForm(companyId, _data.id).then(
            response => {
                var _template = response.data.templateSettings;
                var _temp = {
                    branch: _data.branchId,
                    template: _template.template,
                    mainColor: _template.mainColor,
                    secondaryColor: _template.secondaryColor,
                    appFont: _template.appFont,
                    css: _template.css,
                    logo: _template.logo,
                    iban: _template.iban,
                    moreInfo: _template.moreInfo
                }
                var printData = response.data.saleInstance;
                props.colDef.cellRendererParams.setTemplate(_template);
                var saleInstance = props.colDef.cellRendererParams.getPrintSale(printData);
                saleInstance.LOGO = _temp.logo;
                saleInstance.IBAN = _temp.iban;
                saleInstance.MOREINFO = _temp.moreInfo;
                props.colDef.cellRendererParams.onClickPrint(saleInstance)
            },
            error => {
                console.error(
                    (error.response && error.response.data && error.response.data.message) ||
                    error.message ||
                    error.toString()
                )
            }
        );
    }

    const handleCancel = () => {
        var id = props.data.id;
        var companyId = useStore.getState().selectedCompany.id;
        var mess = props.data.mark ? t("cancelationConfirm0") + " " + t("cancelationConfirm1") : t("cancelationConfirm0");

        confirmAlert({
            title: t("submitConfirm"),
            message: mess,
            submessage: t("cancelationConfirm2"),
            buttons: [
                {
                    label: t('Yes'),
                    onClick: () => {
                        var rowNode = props.node;
                        const seriesNumber = props.data.seriesNumber;
                        props.colDef.cellRendererParams.blockUi(true)
                        ApiClient.cancelMyDataInvoice(companyId, id).then(
                            response => {
                                if (response.data.response[0].statusCode == "Success") {
                                    var cancelMark = response.data.response[0].cancellationMark;
                                    var mark = rowNode.data.mark;
                                    if (cancelMark) {
                                        var _htm = <span className="seriesNumber canceled-series-symbol"><span>{seriesNumber}</span></span>;
                                        rowNode.setDataValue("seriesNumber", _htm);
                                        rowNode.setDataValue("cancelationMark", cancelMark);
                                        rowNode.setDataValue("mark", mark);

                                        const actionel = <div>
                                            <Menu menuButton={<MenuButton><i className="fa fa-bars"></i></MenuButton>} transition>
                                                <MenuItem onClick={handlePrint}><i className="fa fa-print"></i>{t("printMenu")}</MenuItem>
                                                <MenuItem onClick={handleServerPdfDownload}><i className="fa fa-file-pdf-o"></i>{t("saveAsPDFMenu")}</MenuItem>
                                                <MenuItem onClick={hangleEdit}><i className="fa fa-edit"></i>{t("editMenu")}</MenuItem>
                                                <MenuItem onClick={showEmailModal}><i className="fa fa-envelope"></i>{t("sendEmailMenu")}</MenuItem>
                                                <MenuItem onClick={goToPublic}><i className="fa fa-eye"></i>{t("viewInvoiceMenu")}</MenuItem>
                                            </Menu>
                                        </div>
                                        setActionElement(actionel)
                                    }
                                    props.api.refreshInfiniteCache()
                                    if (cancelMark) {
                                        toast.success(t("invoiceCanceled", { mark: cancelMark }), { autoClose: 5000 })
                                    } else {
                                        toast.success(t("invoiceCanceledNoCancelMark"), { autoClose: 5000 })
                                    }
                                } else {
                                    var errors = response.data.response[0].errors.error;
                                    errors.forEach(e => {
                                        toast.error(e.message, { autoClose: 5000 })
                                    })
                                }
                                props.colDef.cellRendererParams.blockUi(false)
                            },
                            error => {
                                console.error(
                                    (error.response && error.response.data && error.response.data.message) ||
                                    error.message ||
                                    error.toString()
                                )
                                props.colDef.cellRendererParams.blockUi(false)
                            }
                        );
                    }
                },
                {
                    label: t('No'),
                    onClick: () => { }
                }
            ]
        });
    }

    useImperativeHandle(ref, () => ({
        refresh(params) { }
    }));

    const showEmailModal = () => {
        var companyId = useStore.getState().selectedCompany.id;
        ApiClient.findCompanyCustomerContacts(companyId, props.data.customerTaxPayerId, props.data.customerName).then(
            response => {
                var contacts = response.data;
                var _contacts = contacts.map(e => ({
                    value: e.email,
                    name: e.name,
                    email: e.email,
                    label: e.email
                }));

                var columns = [
                    { header: t("Name"), field: "name", flex: 6 },
                    { header: t("Email"), field: "email", flex: 6, asLabel: true }
                ]

                var _company = useStore.getState().selectedCompany;
                if (_company.accountantEmail) {
                    _contacts.push({
                        value: _company.accountantEmail,
                        name: t("companyAccountant"),
                        email: _company.accountantEmail,
                        label: _company.accountantEmail
                    })
                }

                var opts = { data: _contacts, columns: columns };
                props.colDef.cellRendererParams.setShowEmailModal(true);
                props.colDef.cellRendererParams.setCustomerContacts(opts);
                props.colDef.cellRendererParams.setLineData(props.data);
            },
            error => {
                console.log(
                    (error.response && error.response.data && error.response.data.message) ||
                    error.message ||
                    error.toString()
                )
            }
        );
    }

    const hangleEdit = () => {
        navigate("/sale/" + props.data.id);
    }

    const publishCredit = () => {
        navigate("/sale/" + props.data.id + "?credit=true");
    }

    const hangleArrangingTransmission = () => {
        var id = props.data.id;
        var companyId = useStore.getState().selectedCompany.id;

        confirmAlert({
            title: t("submitConfirm"),
            message: t("arrangeTransmissionConfirmMessage"),
            submessage: t("arrangeTransmissionConfirmSubMessage"),
            buttons: [
                {
                    label: t('Yes'),
                    onClick: () => {
                        var rowNode = props.node;
                        props.colDef.cellRendererParams.blockUi(true)
                        ApiClient.arrangingTransmission(companyId, id).then(
                            response => {
                                console.log(response.data)
                                props.colDef.cellRendererParams.blockUi(false);
                                props.api.refreshInfiniteCache();
                                toast.success(t("arrangeTransmissionCompleted"), { autoClose: 5000 })
                            },
                            error => {
                                console.error(
                                    (error.response && error.response.data && error.response.data.message) ||
                                    error.message ||
                                    error.toString()
                                )
                                props.colDef.cellRendererParams.blockUi(false)
                            }
                        );
                    }
                },
                {
                    label: t('No'),
                    onClick: () => { }
                }
            ]
        });
    }

    const createPOSTransaction = () => {
        var id = props.data.id;
        var companyId = useStore.getState().selectedCompany.id;

        confirmAlert({
            title: t("submitConfirm"),
            message: t("createPosTransactionConfirmMessage"),
            submessage: t("createPosTransactionConfirmSubMessage"),
            buttons: [
                {
                    label: t('Yes'),
                    onClick: () => {
                        var rowNode = props.node;
                        props.colDef.cellRendererParams.blockUi(true)
                        ApiClient.createPosTransactionForInvoice(companyId, id).then(
                            response => {
                                console.log(response.data)
                                props.colDef.cellRendererParams.blockUi(false);
                                props.api.refreshInfiniteCache();
                            },
                            error => {
                                console.error(
                                    (error.response && error.response.data && error.response.data.message) ||
                                    error.message ||
                                    error.toString()
                                )
                                props.colDef.cellRendererParams.blockUi(false)
                            }
                        );
                    }
                },
                {
                    label: t('No'),
                    onClick: () => { }
                }
            ]
        });
    }

    const goToParochosPrint = () => {   
        window.open(props.data.qrUrl, "_blank");
    }

    const goToParochosPage = () => {
        var qrUrl = props.data.qrUrl;
        qrUrl = qrUrl.replaceAll("/fd/", "/invoices/InvoiceInfo/");
        qrUrl = qrUrl.replaceAll(":1", "");
        window.open(qrUrl, "_blank");
    }



    useEffect(() => {
        if (props.node.data != null) {
            var mark = props.node.data.mark;
            var cancelMark = props.node.data.cancellationMark;
            var parochosProcessId = props.node.data.parochosProcessId;
            var parochosStatus = props.node.data.parochosStatus;
            var containsCreditTransaction = props.node.data.containsCreditTransaction;
            var _company = useStore.getState().selectedCompany;

            props.node.setDataValue("mark", mark);
            props.node.setDataValue("cancelationMark", cancelMark);

            const cancelMenu = !props.node.data.canceled ?
                <MenuItem onClick={handleCancel}>
                    <i className="fa fa-times"></i> {t("cancelInvoiceMenu")}
                </MenuItem>
                : <></>

            const publishMenu = props.node.data ? (
                props.node.data.myDataInvoiceType == "invoice1_1" ||
                    props.node.data.myDataInvoiceType == "invoice1_2" ||
                    props.node.data.myDataInvoiceType == "invoice1_3" ||
                    props.node.data.myDataInvoiceType == "invoice2_1" ?
                    <MenuItem onClick={publishCredit}><i className="fa fa-credit-card"></i>{t("creditInvoiceMenu")}</MenuItem>
                    : <></>
            ) : <></>

            const actionel = <div>
                <Menu position="initial" direction="left" menuButton={<MenuButton><span style={{ color: 'black' }}><i className="fa fa-bars"></i></span></MenuButton>} transition>
                    <MenuItem onClick={handlePrint}><i className="fa fa-print"></i>{t("printMenu")}</MenuItem>
                    <MenuItem onClick={handleServerPdfDownload}><i className="fa fa-file-pdf-o"></i>{t("saveAsPDFMenu")}</MenuItem>
                    {
                        parochosProcessId != null
                            ? <MenuItem onClick={goToParochosPrint}><i className="fa fa-edit"></i>{t("printMenuParochos")}</MenuItem> : <></>
                    }
                    {/* {
                        parochosProcessId != null
                            ? <MenuItem onClick={goToParochosPage}><i className="fa fa-edit"></i>{t("showMenuParochos")}</MenuItem> : <></>
                    } */}
                    {
                        parochosProcessId != null && containsCreditTransaction && parochosStatus == "1"
                            ? <MenuItem onClick={createPOSTransaction}><i className="fa fa-edit"></i>{t("createPOSCreditTransaction")}</MenuItem> : <></>
                    }
                    {
                        parochosProcessId != null && parochosStatus == "0"
                            ? <MenuItem onClick={createPOSTransaction}><i className="fa fa-edit"></i>{t("createPOSTransaction")}</MenuItem> : <></>
                    }
                    {
                        mark == null
                            ? <MenuItem onClick={hangleEdit}><i className="fa fa-edit"></i>{t("editMenu")}</MenuItem> : <></>
                    }
                    <MenuItem onClick={showEmailModal}><i className="fa fa-envelope"></i>{t("sendEmailMenu")}</MenuItem>
                    <MenuItem onClick={goToPublic}><i className="fa fa-eye"></i>{t("viewInvoiceMenu")}</MenuItem>
                    {publishMenu}
                    {
                        _company.myDataProvider == "MYDATA" || mark == null ? cancelMenu : <></>
                    }
                    {
                        props.node.data.parochosStatus == 0 && props.node.data.transmissionFailure == 1
                            ? <MenuItem onClick={hangleArrangingTransmission}><i className="fa fa-edit"></i>{t("ArrangingΤransmission")}</MenuItem> : <></>
                    }
                </Menu>
            </div>
            setActionElement(actionel)
        }
    }, [props.node])

    if (props.node.rowPinned) {
        return <span></span>;
    }

    return (
        <span>{actionElement}</span>
    );
});

export default SaleActionsRenderer;
